import React, { useState } from 'react';
import ProjectCard from '../../components/gallery/ProjectCard';
import { projects, categories } from '../../data/projects';

const Projects = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [sortOrder, setSortOrder] = useState('newest'); // 'newest' or 'oldest'

  const filteredProjects = selectedCategory === 'All' 
    ? projects 
    : projects.filter(project => project.category === selectedCategory);

  // Sort by year
  const sortedProjects = [...filteredProjects].sort((a, b) => {
    if (sortOrder === 'newest') {
      return b.year - a.year; // Newest first
    } else {
      return a.year - b.year; // Oldest first
    }
  });

  return (
    <div className="page-content">
      {/* Hero Section */}
      <section className="page-hero service-hero-grid" style={{
        position: 'relative',
        minHeight: '500px',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        marginTop: '120px',
        paddingTop: '3rem',
        paddingBottom: '3rem'
      }}>
        {/* Image Grid Background */}
        <div className="service-hero-grid-bg" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '1rem',
          padding: '1rem',
          zIndex: 1
        }}>
          {[...Array(8)].map((_, i) => (
            <div key={i} style={{
              background: `linear-gradient(${135 + i * 20}deg, rgba(0, 104, 166, 0.6) 0%, rgba(171, 22, 54, 0.6) 100%)`,
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span className="material-icons" style={{fontSize: '3rem', color: 'rgba(255, 255, 255, 0.3)'}}>
                {['apartment', 'business', 'domain', 'factory', 'location_city', 'store', 'warehouse', 'home_work'][i]}
              </span>
            </div>
          ))}
        </div>
        
        {/* Dark Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          zIndex: 2
        }}></div>
        
        <div className="container" style={{position: 'relative', zIndex: 3, textAlign: 'center', padding: '4rem 20px'}}>
          <div style={{maxWidth: '800px', margin: '0 auto'}}>
            <div className="service-badge" style={{
              display: 'inline-block',
              fontSize: '0.9rem',
              fontWeight: '600',
              color: 'var(--white)',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              paddingBottom: '0.5rem',
              borderBottom: '3px solid var(--accent-blue)',
              marginBottom: '2rem'
            }}>
              Our Work
            </div>
            
            <h1 className="service-title" style={{
              color: 'var(--white)',
              fontSize: '4.5rem',
              fontWeight: '700',
              marginBottom: '1.5rem',
              lineHeight: '1.1'
            }}>
              Our Projects
            </h1>
            
            <p className="service-subtitle" style={{
              color: 'rgba(255, 255, 255, 0.95)',
              fontSize: '1.5rem',
              lineHeight: '1.6',
              marginBottom: '0'
            }}>
              Delivering Excellence Across Arizona Since 1986
            </p>
          </div>
        </div>
      </section>

      {/* Projects Content */}
      <section className="section">
        <div style={{ width: '100%', padding: '0 2rem' }}>
          <div className="section-header">
            <h2>Featured Projects</h2>
            <p>Explore our portfolio of successful mechanical contracting projects</p>
          </div>

          {/* Category Filter */}
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '1rem',
            justifyContent: 'center',
            marginBottom: '2rem'
          }}>
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                style={{
                  padding: '0.75rem 1.5rem',
                  border: selectedCategory === category ? '2px solid var(--accent-blue)' : '2px solid var(--gray-300)',
                  background: selectedCategory === category ? 'var(--accent-blue)' : 'var(--white)',
                  color: selectedCategory === category ? 'var(--white)' : 'var(--gray-600)',
                  borderRadius: '25px',
                  fontSize: '0.95rem',
                  fontWeight: selectedCategory === category ? 'bold' : 'normal',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  if (selectedCategory !== category) {
                    e.target.style.borderColor = 'var(--accent-blue)';
                    e.target.style.color = 'var(--accent-blue)';
                  }
                }}
                onMouseOut={(e) => {
                  if (selectedCategory !== category) {
                    e.target.style.borderColor = 'var(--gray-300)';
                    e.target.style.color = 'var(--gray-600)';
                  }
                }}
              >
                {category}
              </button>
            ))}
          </div>

          {/* Sort Controls */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '1rem',
            marginBottom: '3rem'
          }}>
            <span style={{
              color: 'var(--gray-600)',
              fontSize: '0.95rem',
              fontWeight: 'bold'
            }}>
              Sort by Date:
            </span>
            <div style={{
              display: 'flex',
              gap: '0.5rem',
              border: '2px solid var(--gray-300)',
              borderRadius: '25px',
              overflow: 'hidden'
            }}>
              <button
                onClick={() => setSortOrder('newest')}
                style={{
                  padding: '0.6rem 1.5rem',
                  border: 'none',
                  background: sortOrder === 'newest' ? 'var(--accent2-red)' : 'var(--white)',
                  color: sortOrder === 'newest' ? 'var(--white)' : 'var(--gray-600)',
                  fontSize: '0.9rem',
                  fontWeight: sortOrder === 'newest' ? 'bold' : 'normal',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
              >
                Newest First
              </button>
              <button
                onClick={() => setSortOrder('oldest')}
                style={{
                  padding: '0.6rem 1.5rem',
                  border: 'none',
                  background: sortOrder === 'oldest' ? 'var(--accent2-red)' : 'var(--white)',
                  color: sortOrder === 'oldest' ? 'var(--white)' : 'var(--gray-600)',
                  fontSize: '0.9rem',
                  fontWeight: sortOrder === 'oldest' ? 'bold' : 'normal',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
              >
                Oldest First
              </button>
            </div>
          </div>

          {/* Projects Grid */}
          <div className="projects-grid" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '2rem',
            marginBottom: '3rem'
          }}>
            {sortedProjects.map((project) => (
              <ProjectCard key={project.id} project={project} />
            ))}
          </div>

          {/* No Results Message */}
          {sortedProjects.length === 0 && (
            <div style={{
              textAlign: 'center',
              padding: '3rem',
              color: 'var(--gray-600)'
            }}>
              <p style={{fontSize: '1.2rem'}}>No projects found in this category.</p>
            </div>
          )}
        </div>
      </section>

    </div>
  );
};

export default Projects;

